import { get } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getProfileGroupListHelper = () => get(url.QUERY_BUILDER_PROFILEGROUPS_GET)
export const getProfileListHelper = guid => get(url.QUERY_BUILDER_PROFILES_GET+"?profileGroupGuid="+ guid)
export const getProfileFilterListHelper = guid => get(url.QUERY_BUILDER_PROFILEFILTERS_GET+"?profileGroupGuid="+ guid)